import { US_SPORTS, SOCCER_LEAGUES, isSoccer } from "../lib/sports";

// Shared sport selector: US sports as top-level tabs + one "Soccer" tab that
// reveals a league picker (EPL, La Liga, …). `counts` optionally maps code -> number.
export const SportTabs = ({ value, onChange, counts }) => {
  const soccerActive = isSoccer(value);

  const topCls = (active) =>
    `flex items-center gap-1.5 rounded-xl px-4 py-2 text-sm font-semibold transition-all ${
      active
        ? "bg-[#00E5FF] text-[#0B0F17] cyan-glow"
        : "bg-[#141C2B] border border-[#233248] text-slate-300 hover:border-[#00E5FF]/40"
    }`;

  const count = (code, active) =>
    counts?.[code] != null && (
      <span className={`font-data text-[10px] ${active ? "text-[#0B0F17]/70" : "text-slate-500"}`}>
        {counts[code]}
      </span>
    );

  return (
    <div className="space-y-2">
      <div className="flex gap-2 flex-wrap">
        {US_SPORTS.map((s) => (
          <button key={s} data-testid={`sport-tab-${s.toLowerCase()}`} onClick={() => onChange(s)} className={topCls(value === s)}>
            {s}
            {count(s, value === s)}
          </button>
        ))}
        <button
          data-testid="sport-tab-soccer"
          onClick={() => onChange(soccerActive ? value : "EPL")}
          className={topCls(soccerActive)}
        >
          Soccer
        </button>
      </div>

      {soccerActive && (
        <div data-testid="soccer-league-picker" className="flex gap-2 flex-wrap">
          {SOCCER_LEAGUES.map((l) => {
            const active = value === l.code;
            return (
              <button
                key={l.code}
                data-testid={`league-tab-${l.code.toLowerCase()}`}
                onClick={() => onChange(l.code)}
                className={`flex items-center gap-1 rounded-lg px-3 py-1.5 text-xs font-semibold transition-all ${
                  active
                    ? "bg-[#00E5FF] text-[#0B0F17]"
                    : "bg-[#141C2B] border border-[#233248] text-slate-300 hover:border-[#00E5FF]/40"
                }`}
              >
                {l.label}
                {count(l.code, active)}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};
